/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { useEffect, useState } from 'react';
import _ from 'lodash';
import { types as coreTypes } from '@sitebuilder/core';
import { themes as commonThemes, widgetUtils } from '@sitebuilder/common';
import WidgetsContainer from './WidgetsContainer';
import ComponentsContainer from './ComponentsContainer';
import TypographyContainer from './TypographyContainer';

interface ThemeEditorContainerProps {
    theme: coreTypes.Theme | any;
    themeId: string;
}

const tabs = [
    { label: 'Widgets', value: 'widgets' },
    { label: 'Components', value: 'components' },
    { label: 'Typography', value: 'typography' },
];

const ThemeEditorContainer = (props: ThemeEditorContainerProps | any) => {
    const { theme, themeId } = props;
    const [selectedTab, setSelectedTab] = useState('widgets');
    const [fontFaces, setFontFaces] = useState<string>('');

    useEffect(() => {
        const root = document.documentElement;

        if (themeId && theme) {
            const filteredTheme: any = widgetUtils.getCssTheme(
                theme,
                'rgb',
                commonThemes.defaultTypography,
                commonThemes.componentThemes
            );

            if (filteredTheme) {
                const defaultThemeFonts = filteredTheme?.defaultFonts
                    ? [...filteredTheme.defaultFonts]
                    : commonThemes.defaultFonts;
                const fonts = filteredTheme?.userFonts
                    ? [...defaultThemeFonts, ...filteredTheme.userFonts]
                    : [...defaultThemeFonts];

                root.style.cssText = widgetUtils.getCssString(
                    {
                        ...(filteredTheme.colors as any),
                        ...commonThemes.defaultColors,
                        ...filteredTheme.defaultColors,
                    },
                    { ...(filteredTheme.typography as any), ...filteredTheme.userTypography },
                    _.merge(commonThemes.componentThemes, filteredTheme.componentThemes)
                );

                setFontFaces(widgetUtils.getFontFace(fonts));
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [theme, themeId]);

    return (
        <div
            className="theme-editor"
            css={css`
                ${fontFaces}
            `}
        >
            <main className="main">
                <div className="tab">
                    {tabs.map((tab: any) => (
                        <button
                            key={tab.label}
                            className={`tab-link ${
                                selectedTab === tab.value ? 'selected-tab' : ''
                            }`}
                            onClick={() => setSelectedTab(tab.value)}
                        >
                            {tab.label}
                        </button>
                    ))}
                </div>
                <div className="tab-content">
                    {selectedTab === 'widgets' && <WidgetsContainer />}
                    {selectedTab === 'components' && <ComponentsContainer />}
                    {selectedTab === 'typography' && <TypographyContainer />}
                </div>
            </main>
        </div>
    );
};

export default ThemeEditorContainer;
